import { theme } from '../store/global';
import { setTheme } from '../lib/auth';
import { PageHeader } from '../components/PageHeader';

export function Settings() {
  return (
    <div class="mx-auto max-w-7xl px-6 py-6">
      <PageHeader
        title="Configurações"
        description="Preferências locais. Endpoints e tokens ficam na sidebar."
        icon={<i class="ph ph-gear text-xl" />}
      />

      <div class="flex flex-col gap-6">
        <Field label="Tema">
          <div class="flex gap-1.5">
            {(['light', 'dark', 'auto'] as const).map((t) => {
              const icon = t === 'light' ? 'ph-sun' : t === 'dark' ? 'ph-moon' : 'ph-monitor';
              const isActive = theme.value === t;
              return (
                <button
                  class={`inline-flex items-center justify-center gap-2 h-8 px-4 rounded-md text-sm font-medium border focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 ${
                    isActive
                      ? 'bg-sidebar-accent text-sidebar-accent-foreground border-transparent'
                      : 'bg-background text-foreground border-input shadow-xs hover:bg-accent hover:text-accent-foreground'
                  }`}
                  onClick={() => {
                    setTheme(t);
                    theme.value = t;
                  }}
                >
                  <i class={`${isActive ? 'ph-bold' : 'ph'} ${icon} text-sm`} />
                  {t === 'light' ? 'Claro' : t === 'dark' ? 'Escuro' : 'Automático'}
                </button>
              );
            })}
          </div>
        </Field>

        <div class="border-t border-border pt-5 text-xs text-muted-foreground space-y-1">
          <p>Endpoints e tokens são gerenciados pela árvore na sidebar esquerda.</p>
          <p>Cada endpoint guarda seu próprio token no localStorage do navegador.</p>
          <p>
            O <strong>user_id</strong> usado no chat fica na própria tela do chat (botão{' '}
            <span class="font-mono">como: …</span> no toolbar) — é específico de cada
            conversa, não preferência global.
          </p>
        </div>
      </div>
    </div>
  );
}

function Field({
  label,
  hint,
  children,
}: {
  label: string;
  hint?: string;
  children: preact.ComponentChildren;
}) {
  return (
    <div>
      <label class="text-sm font-medium block mb-1">{label}</label>
      {children}
      {hint && <p class="text-xs text-muted-foreground mt-1">{hint}</p>}
    </div>
  );
}
